import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { Subject, takeUntil } from 'rxjs';
import { LoaderService } from '../../../services/loader/loader.service';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [CommonModule, ProgressSpinnerModule],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss',
})
export class LoaderComponent implements OnInit, OnDestroy {
  public isLoading = false;
  private destroy$ = new Subject<void>();

  constructor(private loaderService: LoaderService) {}

  ngOnInit() {
    this.loaderService.isLoading$
      .pipe(takeUntil(this.destroy$))
      .subscribe((value) => {
        this.isLoading = value;
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
